// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__26W0j","list":"BalanceDue_list__3AQXI","listRow":"BalanceDue_listRow__3Zfcy","total":"BalanceDue_total__1MIu0"};